import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../utils/TableCustomStyles";
import Select from "react-select";
import { format } from "date-fns";

function SlotAgreement() {
  const addform = useRef(null);
  const addslotrateform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [portData, setPortData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [updateServiceData, setUpdateServiceData] = useState([]);
  const [slotRateData, setSlotRateData] = useState([]);
  const [containerTypeData, setContainerTypeData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [slotRateDataPending, setSlotRateDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  const [fromPort, setFromPort] = useState(false);

  const [showOperatorError, setShowOperatorError] = useState(false);
  const [showAgentError, setShowAgentError] = useState(false);
  const [showFromPortError, setShowFromPortError] = useState(false);
  const [showToPortError, setShowToPortError] = useState(false);
  const [showServiceError, setShowServiceError] = useState(false);
  const [showFreightTermsFromError, setShowFreightTermsFromError] = useState(false);
  const [showFreightTermsToError, setShowFreightTermsToError] = useState(false);
  const [showValidFromError, setShowValidFromError] = useState(false);
  const [showValidUptoError, setShowValidUptoError] = useState(false);
  const [showVendorAgreementNumberError, setShowVendorAgreementNumberError] = useState(false);
  const [showAgreementDateError, setShowAgreementDateError] = useState(false);
  const [showNotesError, setShowNotesError] = useState(false);


  const [showUpdateOperatorError, setShowUpdateOperatorError] = useState(false);
  const [showUpdateAgentError, setShowUpdateAgentError] = useState(false);
  const [showUpdateFromPortError, setShowUpdateFromPortError] = useState(false);
  const [showUpdateToPortError, setShowUpdateToPortError] = useState(false);
  const [showUpdateServiceError, setShowUpdateServiceError] = useState(false);
  const [showUpdateFreightTermsFromError, setShowUpdateFreightTermsFromError] = useState(false);
  const [showUpdateFreightTermsToError, setShowUpdateFreightTermsToError] = useState(false);
  const [showUpdateValidFromError, setShowUpdateValidFromError] = useState(false);
  const [showUpdateValidUptoError, setShowUpdateValidUptoError] = useState(false);
  const [showUpdateVendorAgreementNumberError, setShowUpdateVendorAgreementNumberError] = useState(false);
  const [showUpdateAgreementDateError, setShowUpdateAgreementDateError] = useState(false);
  const [showUpdateNotesError, setShowUpdateNotesError] = useState(false);
  

  const [updateId, setUpdateId] = useState("");
  const [updateOperator, setUpdateOperator] = useState(false);
  const [updateAgent, setUpdateAgent] = useState(false);
  const [updateFromPort, setUpdateFromPort] = useState(false);
  const [updateToPort, setUpdateToPort] = useState(false);
  const [updateService, setUpdateService] = useState(false);
  const [updateSchedule, setUpdateSchedule] = useState(false);
  const [updateFreightTermsFrom, setUpdateFreightTermsFrom] = useState(false);
  const [updateFreightTermsTo, setUpdateFreightTermsTo] = useState(false);
  const [updateValidFrom, setUpdateValidFrom] = useState(false);
  const [updateValidUpto, setUpdateValidUpto] = useState(false);
  const [updateVendorAgreementNumber, setUpdateVendorAgreementNumber] = useState(false);
  const [updateAgreementDate, setUpdateAgreementDate] = useState(false);
  // const [updateLaden20, setUpdateLaden20] = useState(false);
  // const [updateLaden40, setUpdateLaden40] = useState(false);
  // const [updateEmpty20, setUpdateEmpty20] = useState(false);
  // const [updateEmpty40, setUpdateEmpty40] = useState(false);
  // const [updateWrsTeuLaden, setUpdateWrsTeuLaden] = useState(false);
  // const [updateWrsTeuEmpty, setUpdateWrsTeuEmpty] = useState(false);
  // const [updateGriTeuLaden, setUpdateGriTeuLaden] = useState(false);
  // const [updateGriTeuEmpty, setUpdateGriTeuEmpty] = useState(false);
  // const [updateLssTeuLaden, setUpdateLssTeuLaden] = useState(false);
  // const [updateLssTeuEmpty, setUpdateLssTeuEmpty] = useState(false);
  // const [updateBafTeuLaden, setUpdateBafTeuLaden] = useState(false);
  // const [updateBafTeuEmpty, setUpdateBafTeuEmpty] = useState(false);
  // const [updateEcrsTeuLaden, setUpdateEcrsTeuLaden] = useState(false);
  // const [updateEcrsTeuEmpty, setUpdateEcrsTeuEmpty] = useState(false);
  // const [updateDg20Sc, setUpdateDg20Sc] = useState(false);
  // const [updateDg40Sc, setUpdateDg40Sc] = useState(false);
  // const [updateFlexiScPerTeu, setUpdateFlexiScPerTeu] = useState(false);
  // const [updateReeferScPerPlug, setUpdateReeferScPerPlug] = useState(false);
  // const [updateIsoUnit20Laden, setUpdateIsoUnit20Laden] = useState(false);
  // const [updateIsoUnit20Empty, setUpdateIsoUnit20Empty] = useState(false);
  // const [updatePcsLaden, setUpdatePcsLaden] = useState(false);
  // const [updatePcsEmpty, setUpdatePcsEmpty] = useState(false);
  // const [updateOdoTeuLaden, setUpdateOdoTeuLaden] = useState(false);
  // const [updateOdoTeuEmpty, setUpdateOdoTeuEmpty] = useState(false);
  // const [updateCallPort, setUpdateCallPort] = useState(false);
  const [updateNotes, setUpdateNotes] = useState(false);
  const [showSlotAgreementDetails, setShowSlotAgreementDetails] = useState(true);
  const [showSlotRates, setShowSlotRates] = useState(false);


  const getLoggenInUser = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
        if (response) {
            setLoggedInUser(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }
  
  const getSlotAgreement = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/slotagreement/');
        if (response) {
            setData(response.data)
            setDataPending(false)
        }
        
    } catch (err) {
        toast.error("Error in fetching slot agreement data! Try again.");
    }
  }

  const getOperator = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/operator/');
        if (response) {
            setOperatorData(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching operator data! Try again.");
    }
  }

  const getAgent = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/agent/');
        if (response) {
            setAgentData(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching agent data! Try again.");
    }
  }

  const getPort = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/port/');
        if (response) {
            setPortData(response.data)
        }        
    } catch (err) {
        toast.error("Error in fetching port data! Try again.");
    }
  }

  const getService = async (from_port, to_port) => {
    if(from_port && to_port){
      try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/vesselservice/getvesselserviceforslot?from='+from_port+"&to="+to_port);
          if (response) {
              setServiceData(response.data)
          }        
      } catch (err) {
          toast.error("Error in fetching vessel service data! Try again.");
      }
    }
  }

  const getUpdateService = async (from_port, to_port) => {
    if(from_port && to_port){
      try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/vesselservice/getvesselserviceforslot?from='+from_port+"&to="+to_port);
          if (response) {
            console.log("SERVIVE-------", response)
            setUpdateServiceData(response.data)
          }        
      } catch (err) {
          toast.error("Error in fetching vessel service data! Try again.");
      }
    }
  }

  const getContainerType = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/product/');
        if (response) {
            const container_data = Array.isArray(response?.data) ? response.data.filter(product => product.type === "CONTAINER"): [];
            setContainerTypeData(container_data)
        }
    } catch (err) {
        toast.error("Error in fetching container type data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/currency/');
        if (response) {
            setCurrencyData(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching currency data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data?.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array?.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true)
    setRecordForDelete(data)
  }

  const handleSetAddData = () => {
    addform.current.operator.value = ""
    addform.current.agent.value = ""
    addform.current.from_port.value = ""
    addform.current.to_port.value = ""
    addform.current.service.value = ""
    addform.current.freight_terms_from.value = ""
    addform.current.freight_terms_to.value = ""
    addform.current.valid_from.value = ""
    addform.current.valid_upto.value = ""
    addform.current.vendor_agreement_number.value = ""
    addform.current.agreement_date.value = ""
    // addform.current.laden_20.value = 0.0
    // addform.current.laden_40.value = 0.0
    // addform.current.empty_20.value = 0.0
    // addform.current.empty_40.value = 0.0
    // addform.current.wrs_teu_laden.value = 0.0
    // addform.current.wrs_teu_empty.value = 0.0
    // addform.current.gri_teu_laden.value = 0.0
    // addform.current.gri_teu_empty.value = 0.0
    // addform.current.lss_teu_laden.value = 0.0
    // addform.current.lss_teu_empty.value = 0.0
    // addform.current.baf_teu_laden.value = 0.0
    // addform.current.baf_teu_empty.value = 0.0
    // addform.current.ecrs_teu_laden.value = 0.0
    // addform.current.ecrs_teu_empty.value = 0.0
    // addform.current.dg_20_s_c.value = 0.0
    // addform.current.dg_40_s_c.value = 0.0
    // addform.current.flexi_s_c_per_teu.value = 0.0
    // addform.current.reefer_s_c_per_plug.value = 0.0
    // addform.current.iso_unit_20_laden.value = 0.0
    // addform.current.iso_unit_20_empty.value = 0.0
    // addform.current.pcs_laden.value = 0.0
    // addform.current.pcs_empty.value = 0.0
    // addform.current.odo_teu_laden.value = 0.0
    // addform.current.odo_teu_empty.value = 0.0
    addform.current.notes.value = ""
  }

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id)
    setUpdateOperator(row.operator)
    setUpdateAgent(row.agent)
    setUpdateFromPort(row.from_port)
    setUpdateToPort(row.to_port)
    setUpdateService(row.service)
    setUpdateFreightTermsFrom(row.freight_terms_from)
    setUpdateFreightTermsTo(row.freight_terms_to)
    setUpdateValidFrom(row.valid_from)
    setUpdateValidUpto(row.valid_upto)
    setUpdateVendorAgreementNumber(row.vendor_agreement_number)
    setUpdateAgreementDate(row.agreement_date)
    // setUpdateLaden20(row.laden_20)
    // setUpdateLaden40(row.laden_40)
    // setUpdateEmpty20(row.empty_20)
    // setUpdateEmpty40(row.empty_40)
    // setUpdateWrsTeuLaden(row.wrs_teu_laden)
    // setUpdateWrsTeuEmpty(row.wrs_teu_empty)
    // setUpdateGriTeuLaden(row.gri_teu_laden)
    // setUpdateGriTeuEmpty(row.gri_teu_empty)
    // setUpdateLssTeuLaden(row.lss_teu_laden)
    // setUpdateLssTeuEmpty(row.lss_teu_empty)
    // setUpdateBafTeuLaden(row.baf_teu_laden)
    // setUpdateBafTeuEmpty(row.baf_teu_empty)
    // setUpdateEcrsTeuLaden(row.ecrs_teu_laden)
    // setUpdateEcrsTeuEmpty(row.ecrs_teu_empty)
    // setUpdateDg20Sc(row.dg_20_s_c)
    // setUpdateDg40Sc(row.dg_40_s_c)
    // setUpdateFlexiScPerTeu(row.flexi_s_c_per_teu)
    // setUpdateReeferScPerPlug(row.reefer_s_c_per_plug)
    // setUpdateIsoUnit20Laden(row.iso_unit_20_laden)
    // setUpdateIsoUnit20Empty(row.iso_unit_20_empty)
    // setUpdatePcsLaden(row.pcs_laden)
    // setUpdatePcsEmpty(row.pcs_empty)
    // setUpdateOdoTeuLaden(row.odo_teu_laden)
    // setUpdateOdoTeuEmpty(row.odo_teu_empty)
    // setUpdateCallPort(row.call_port)
    setUpdateNotes(row.notes)
    setShowSlotAgreementDetails(true)
    setShowSlotRates(false)
    getSlotRate(row.id)
    getContainerType()
    getCurrency()
    getUpdateService(row.from_port, row.to_port)
    setUpdateSchedule(row.schedule)
  }

  useEffect(() => {
    getLoggenInUser()
    getSlotAgreement()
    getOperator()
    getAgent()
    getPort()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const columns = [
    {
      name: 'Operator',
      selector: row => row.operator_data?.name,
      sortable: true,
    },
    {
      name: 'Agent',
      selector: row => row.agent_data?.name,
      sortable: true,
    },
    {
      name: 'From Port',
      selector: row => row.from_port_data?.name,
      sortable: true,
    },
    {
      name: 'To Port',
      selector: row => row.to_port_data?.name,
      sortable: true,
    },
    // {
    //   name: 'Call Port',
    //   selector: row => row.call_port,
    //   sortable: true,
    // },
    {
      name: 'Service',
      selector: row => row.service_data?.name,
      sortable: true,
    },
    {
      name: 'Freight Terms From',
      selector: row => row.freight_terms_from,
      sortable: true,
    },
    {
      name: 'Freight Terms To',
      selector: row => row.freight_terms_to,
      sortable: true,
    },
    {
      name: 'Valid From',
      selector: row => row.valid_from,
      sortable: true,
    },
    {
      name: 'Valid Upto',
      selector: row => row.valid_upto,
      sortable: true,
    },
    {
      name: 'Vendor Agreement Number',
      selector: row => row.vendor_agreement_number,
      sortable: true,
    },
    {
      name: 'Agreement Date',
      selector: row => row.agreement_date,
      sortable: true,
    },
    // {
    //   name: 'LADEN 20',
    //   selector: row => row.laden_20,
    //   sortable: true,
    // },
    // {
    //   name: 'LADEN 40',
    //   selector: row => row.laden_40,
    //   sortable: true,
    // },
    // {
    //   name: 'EMPTY 20',
    //   selector: row => row.empty_20,
    //   sortable: true,
    // },
    // {
    //   name: 'EMPTY 40',
    //   selector: row => row.empty_40,
    //   sortable: true,
    // },
    // {
    //   name: 'WRS/TEU LADEN',
    //   selector: row => row.wrs_teu_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'WRS/TEU EMPTY',
    //   selector: row => row.wrs_teu_empty,
    //   sortable: true,
    // },
    // {
    //   name: 'GRI/TEU LADEN',
    //   selector: row => row.gri_teu_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'GRI/TEU EMPTY',
    //   selector: row => row.gri_teu_empty,
    //   sortable: true,
    // },
    // {
    //   name: 'LSS/TEU LADEN',
    //   selector: row => row.lss_teu_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'LSS/TEU EMPTY',
    //   selector: row => row.lss_teu_empty,
    //   sortable: true,
    // },
    // {
    //   name: 'BAF/TEU LADEN',
    //   selector: row => row.baf_teu_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'BAF/TEU EMPTY',
    //   selector: row => row.baf_teu_empty,
    //   sortable: true,
    // },
    // {
    //   name: 'ECRS/TEU LADEN',
    //   selector: row => row.ecrs_teu_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'ECRS/TEU EMPTY',
    //   selector: row => row.ecrs_teu_empty,
    //   sortable: true,
    // },
    // {
    //   name: '20 DG S/C',
    //   selector: row => row.dg_20_s_c,
    //   sortable: true,
    // },
    // {
    //   name: '40 DG S/C',
    //   selector: row => row.dg_40_s_c,
    //   sortable: true,
    // },
    // {
    //   name: 'FLEXI S/C PER TEU',
    //   selector: row => row.flexi_s_c_per_teu,
    //   sortable: true,
    // },
    // {
    //   name: 'REEFER S/C PER PLUG',
    //   selector: row => row.reefer_s_c_per_plug,
    //   sortable: true,
    // },
    // {
    //   name: 'ISO UNIT 20 LADEN',
    //   selector: row => row.iso_unit_20_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'ISO UNIT 20 EMPTY',
    //   selector: row => row.iso_unit_20_empty,
    //   sortable: true,
    // },
    // {
    //   name: 'PCS LADEN',
    //   selector: row => row.pcs_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'PCS EMPTY',
    //   selector: row => row.pcs_empty,
    //   sortable: true,
    // },
    // {
    //   name: 'ODO TEU LADEN',
    //   selector: row => row.odo_teu_laden,
    //   sortable: true,
    // },
    // {
    //   name: 'ODO TEU EMPTY',
    //   selector: row => row.odo_teu_empty,
    //   sortable: true,
    // },
    {
      name: 'Notes',
      selector: row => row.notes,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("ratesheet:slotagreement:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("ratesheet:slotagreement:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/master/slotagreement/'+id+'/');
        setShowDeleteModal(false)
        getSlotAgreement()
        toast.success("Record deleted successfully")
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    getSlotAgreement()
    setShowDeleteLoader(false)
  }

  const addNewSlotAgreement = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)

    if(addform.current.operator.value == ""){
      toast.warning("Operator is required")
    }
    else if(addform.current.agent.value == ""){
      toast.warning("Agent is required")
    }
    else if(addform.current.from_port.value == ""){
      toast.warning("Origin port is required")
    }
    else if(addform.current.to_port.value == ""){
      toast.warning("Destination port is required")
    }
    else if(addform.current.service.value == ""){
      toast.warning("Vessel service is required")
    }
    else if(addform.current.freight_terms_from.value == ""){
      toast.warning("Freight origin terms are required")
    }
    else if(addform.current.freight_terms_to.value == ""){
      toast.warning("Freight destination terms are required")
    }
    else if(addform.current.valid_from.value == ""){
      toast.warning("Valid from is required")
    }
    else if(addform.current.valid_upto.value == ""){
      toast.warning("Valid upto is required")
    }
    else if(addform.current.vendor_agreement_number.value == ""){
      toast.warning("Agrrement number is required")
    }
    else if(addform.current.agreement_date.value == ""){
      toast.warning("Agreement date is required")
    }
    else{
      const data = {
        operator: addform.current.operator.value,
        agent: addform.current.agent.value,
        from_port: addform.current.from_port.value,
        to_port: addform.current.to_port.value,
        service: addform.current.service.value,
        freight_terms_from: addform.current.freight_terms_from.value,
        freight_terms_to: addform.current.freight_terms_to.value,
        valid_from: addform.current.valid_from.value,
        valid_upto: addform.current.valid_upto.value,
        vendor_agreement_number: addform.current.vendor_agreement_number.value,
        agreement_date: addform.current.agreement_date.value,
        // laden_20: addform.current.laden_20.value,
        // laden_40: addform.current.laden_40.value,
        // empty_20: addform.current.empty_20.value,
        // empty_40: addform.current.empty_40.value,
        // wrs_teu_laden: addform.current.wrs_teu_laden.value,
        // wrs_teu_empty: addform.current.wrs_teu_empty.value,
        // gri_teu_laden: addform.current.gri_teu_laden.value,
        // gri_teu_empty: addform.current.gri_teu_empty.value,
        // lss_teu_laden: addform.current.lss_teu_laden.value,
        // lss_teu_empty: addform.current.lss_teu_empty.value,
        // baf_teu_laden: addform.current.baf_teu_laden.value,
        // baf_teu_empty: addform.current.baf_teu_empty.value,
        // ecrs_teu_laden: addform.current.ecrs_teu_laden.value,
        // ecrs_teu_empty: addform.current.ecrs_teu_empty.value,
        // dg_20_s_c: addform.current.dg_20_s_c.value,
        // dg_40_s_c: addform.current.dg_40_s_c.value,
        // flexi_s_c_per_teu: addform.current.flexi_s_c_per_teu.value,
        // reefer_s_c_per_plug: addform.current.reefer_s_c_per_plug.value,
        // iso_unit_20_laden: addform.current.iso_unit_20_laden.value,
        // iso_unit_20_empty: addform.current.iso_unit_20_empty.value,
        // pcs_laden: addform.current.pcs_laden.value,
        // pcs_empty: addform.current.pcs_empty.value,
        // odo_teu_laden: addform.current.odo_teu_laden.value,
        // odo_teu_empty: addform.current.odo_teu_empty.value,
        notes: addform.current.notes.value,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/slotagreement/', data,  
        {
          headers: { 'content-type': 'application/json'}
        }
      );

      if (response.status === 201 ) {
        toast.success("Slot Agreement Created Successfully")
      }

      addform.current.operator.value = ""
      addform.current.agent.value = ""
      addform.current.from_port.value = ""
      addform.current.to_port.value = ""
      addform.current.service.value = ""
      addform.current.freight_terms_from.value = ""
      addform.current.freight_terms_to.value = ""
      addform.current.valid_from.value = ""
      addform.current.valid_upto.value = ""
      addform.current.vendor_agreement_number.value = ""
      addform.current.agreement_date.value = ""
      // addform.current.laden_20.value = 0.0
      // addform.current.laden_40.value = 0.0
      // addform.current.empty_20.value = 0.0
      // addform.current.empty_40.value = 0.0
      // addform.current.wrs_teu_laden.value = 0.0
      // addform.current.wrs_teu_empty.value = 0.0
      // addform.current.gri_teu_laden.value = 0.0
      // addform.current.gri_teu_empty.value = 0.0
      // addform.current.lss_teu_laden.value = 0.0
      // addform.current.lss_teu_empty.value = 0.0
      // addform.current.baf_teu_laden.value = 0.0
      // addform.current.baf_teu_empty.value = 0.0
      // addform.current.ecrs_teu_laden.value = 0.0
      // addform.current.ecrs_teu_empty.value = 0.0
      // addform.current.dg_20_s_c.value = 0.0
      // addform.current.dg_40_s_c.value = 0.0
      // addform.current.flexi_s_c_per_teu.value = 0.0
      // addform.current.reefer_s_c_per_plug.value = 0.0
      // addform.current.iso_unit_20_laden.value = 0.0
      // addform.current.iso_unit_20_empty.value = 0.0
      // addform.current.pcs_laden.value = 0.0
      // addform.current.pcs_empty.value = 0.0
      // addform.current.odo_teu_laden.value = 0.0
      // addform.current.odo_teu_empty.value = 0.0
      addform.current.notes.value = ""

      getSlotAgreement()
      setShowAddCanvas(false)
    }
    setShowAddLoader(false)
  }

  const updateSlotAgreement = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)

    console.log("updateValidFrom", updateValidFrom)

    if(updateOperator == "" | updateOperator == null){
      toast.warning("Operator is required")
    }
    else if(updateAgent == "" | updateAgent == null){
      toast.warning("Agent is required")
    }
    else if(updateFromPort == "" | updateFromPort == null){
      toast.warning("Origin port is required")
    }
    else if(updateToPort == "" | updateToPort == null){
      toast.warning("Destination port is required")
    }
    else if(updateService == "" | updateService == null){
      toast.warning("Vessel service is required")
    }
    else if(updateFreightTermsFrom == ""){
      toast.warning("Freight origin terms are required")
    }
    else if(updateFreightTermsTo == ""){
      toast.warning("Freight destination terms are required")
    }
    else if(updateValidFrom == "" | updateValidFrom == null){
      toast.warning("Valid from is required")
    }
    else if(updateValidUpto == "" | updateValidUpto == null){
      toast.warning("Valid upto is required")
    }
    else if(updateVendorAgreementNumber == "" | updateVendorAgreementNumber == null){
      toast.warning("Agreement number is required")
    }
    else if(updateAgreementDate == "" | updateAgreementDate == null){
      toast.warning("Agreement date is required")
    }
    else{
      const id = updateId
      const data = {
        operator: updateOperator,
        agent: updateAgent,
        from_port: updateFromPort,
        to_port: updateToPort,
        service: updateService,
        freight_terms_from: updateFreightTermsFrom,
        freight_terms_to: updateFreightTermsTo,
        valid_from: updateValidFrom,
        valid_upto: updateValidUpto,
        vendor_agreement_number: updateVendorAgreementNumber,
        agreement_date: updateAgreementDate,
        // laden_20: updateLaden20,
        // laden_40: updateLaden40,
        // empty_20: updateEmpty20,
        // empty_40: updateEmpty40,
        // wrs_teu_laden: updateWrsTeuLaden,
        // wrs_teu_empty: updateWrsTeuEmpty,
        // gri_teu_laden: updateGriTeuLaden,
        // gri_teu_empty: updateGriTeuEmpty,
        // lss_teu_laden: updateLssTeuLaden,
        // lss_teu_empty: updateLssTeuEmpty,
        // baf_teu_laden: updateBafTeuLaden,
        // baf_teu_empty: updateBafTeuEmpty,
        // ecrs_teu_laden: updateEcrsTeuLaden,
        // ecrs_teu_empty: updateEcrsTeuEmpty,
        // dg_20_s_c: updateDg20Sc,
        // dg_40_s_c: updateDg40Sc,
        // flexi_s_c_per_teu: updateFlexiScPerTeu,
        // reefer_s_c_per_plug: updateReeferScPerPlug,
        // iso_unit_20_laden: updateIsoUnit20Laden,
        // iso_unit_20_empty: updateIsoUnit20Empty,
        // pcs_laden: updatePcsLaden,
        // pcs_empty: updatePcsEmpty,
        // odo_teu_laden: updateOdoTeuLaden,
        // odo_teu_empty: updateOdoTeuEmpty,
        notes: updateNotes,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/master/slotagreement/'+id+'/', data,  
        {
          headers: { 'content-type': 'application/json'}
        }
      );
      if (response.status === 200 ) {
        toast.success("Slot Agreement updated Successfully")
      }
      getSlotAgreement()
      setShowUpdateCanvas(false)
    }
    setShowUpdateLoader(false)
  }

  // --------------------------------------- Slot Rates ------------------------------------
  const [showSlotAgreementError, setShowSlotAgreementError] = useState(false);
  const [showContainerTypeError, setShowContainerTypeError] = useState(false);
  const [showCargoTypeError, setShowCargoTypeError] = useState(false);
  const [showCurrencyError, setShowCurrencyError] = useState(false);
  const [showRateError, setShowRateError] = useState(false);

  const [showUpdateSlotAgreementError, setShowUpdateSlotAgreementError] = useState(false);
  const [showUpdateContainerTypeError, setShowUpdateContainerTypeError] = useState(false);
  const [showUpdateCargoTypeError, setShowUpdateCargoTypeError] = useState(false);
  const [showUpdateCurrencyError, setShowUpdateCurrencyError] = useState(false);
  const [showUpdateRateError, setShowUpdateRateError] = useState(false);

  const [showDeleteSlotRateModal, setShowDeleteSlotRateModal] = useState(false);
  const [showAddSlotRateModal, setShowAddSlotRateModal] = useState(false);
  const [showUpdateSlotRateModal, setShowUpdateSlotRateModal] = useState(false);
  const [slotRateRecordForDelete, setSlotRateRecordForDelete] = useState(null);
  
  const [slotRateAgreement, setSlotRateAgreement] = useState("");
  const [containerType, setContainerType] = useState("");
  const [cargoType, setCargoType] = useState("");
  const [currency, setCurrency] = useState("");
  const [rate, setRate] = useState(0);

  const [updateSlotRateId, setUpdateSlotRateId] = useState("");
  const [updateSlotRateAgreement, setUpdateSlotRateAgreement] = useState("");
  const [updateContainerType, setUpdateContainerType] = useState("");
  const [updateCargoType, setUpdateCargoType] = useState("");
  const [updateCurrency, setUpdateCurrency] = useState("");
  const [updateRate, setUpdateRate] = useState(0);

  const slotratecolumns = [
    {
      name: 'Slot Agreement',
      width: '500px',
      selector: row => row.slot_agreement_data?.operator_data?.name + " ("+ row.slot_agreement_data?.from_port_data?.name +" - "+ row.slot_agreement_data?.to_port_data?.name +")",
      sortable: true,
    },
    {
      name: 'Container Type',
      selector: row => row.container_type_data?.product_name,
      sortable: true,
    },
    {
      name: 'Cargo Type',
      selector: row => row.cargo_type,
      sortable: true,
    },
    {
      name: 'Currency',
      selector: row => row.currency_data?.name +" ("+ row.currency_data?.symbol +")" ,
      sortable: true,
    },
    {
      name: 'Rate',
      selector: row => row.rate,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("master:slotagreement:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" onClick={() => handleSetUpdateSlotRateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("master:slotagreement:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteSlotRateModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const getSlotRate = async (id) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate?slot_agreement='+id);
        if (response) {
            setSlotRateData(response.data)
            setSlotRateDataPending(false)
        }
    } catch (err) {
        toast.error("Error in fetching slot rate data! Try again.");
    }
  }

  const handleDeleteSlotRateModalClose = () => {
    setShowDeleteSlotRateModal(false)
  }

  const handleDeleteSlotRateModalOpen = (data) => {
    setShowDeleteSlotRateModal(true)
    setSlotRateRecordForDelete(data)
  }

  const handleAddSlotRateModalOpen = () => {
    setShowAddSlotRateModal(true)
  }

  // const handleSetSlotRateAddData = () => {
  //   addslotrateform.current.slot_agreement.value = ""
  //   addslotrateform.current.container_type.value = ""
  //   addslotrateform.current.cargo_type.value = ""
  //   addslotrateform.current.currency.value = ""
  //   addslotrateform.current.rate.value = ""
  // }

  // const closeAddSlotRateForm = () => {
  //   addslotrateform.current.slot_agreement.value = ""
  //   addslotrateform.current.container_type.value = ""
  //   addslotrateform.current.cargo_type.value = ""
  //   addslotrateform.current.currency.value = ""
  //   addslotrateform.current.rate.value = ""

  //   setShowSlotAgreementError(false)
  //   setShowContainerTypeError(false)
  //   setShowCargoTypeError(false)
  //   setShowCurrencyError(false)
  //   setShowRateError(false)
  // }

  const handleSetUpdateSlotRateData = (row) => {
    setShowUpdateSlotRateModal(true)
    setUpdateSlotRateId(row.id)
    setUpdateSlotRateAgreement(row.slot_agreement)
    setUpdateContainerType(row.container_type)
    setUpdateCargoType(row.cargo_type)
    setUpdateCurrency(row.currency)
    setUpdateRate(row.rate)
  }

  const deleteSelectedSlotRateRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
        const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/'+id+'/');
        setShowDeleteSlotRateModal(false)
        if(response.status == 204){
          toast.success("Record deleted successfully")
        }
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    getSlotRate(updateId)
    setShowDeleteLoader(false)
  }

  const addNewSlotRate = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)

    if(addslotrateform.current.slot_agreement.value == ""){
      toast.warning("Slot Agreement is required")
    }
    else if(addslotrateform.current.container_type.value == ""){
      toast.warning("Container Type is required")
    }
    else if(addslotrateform.current.cargo_type.value == ""){
      toast.warning("Cargo Type is required")
    }
    else if(addslotrateform.current.currency.value == ""){
      toast.warning("Currency is required")
    }
    else if(addslotrateform.current.rate.value == "" | addslotrateform.current.rate.value <= 0){
      toast.warning("Slot Rate is required")
    }
    else{
      const data = {
      slot_agreement: addslotrateform.current.slot_agreement.value,
      container_type: addslotrateform.current.container_type.value,
      cargo_type: addslotrateform.current.cargo_type.value,
      currency: addslotrateform.current.currency.value,
      rate: addslotrateform.current.rate.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/', data,  
        {
          headers: { 'content-type': 'application/json'}
        }
      );

      if (response.status == "201" ) {
        toast.success("Slot Rate Created Successfully")
      }

      addslotrateform.current.slot_agreement.value = ""
      addslotrateform.current.container_type.value = ""
      addslotrateform.current.cargo_type.value = ""
      addslotrateform.current.currency.value = ""
      addslotrateform.current.rate.value = ""
      getSlotRate(updateId)
      setShowAddCanvas(false)
    }
    setShowAddLoader(false)
  }

  const updateSlotRate = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)

    if(updateSlotAgreement == ""){
      toast.warning("Slot Agreement is required")
    }
    else if(updateContainerType == ""){
      toast.warning("Container Type is required")
    }
    else if(updateCargoType == ""){
      toast.warning("Cargo Type is required")
    }
    else if(updateCurrency == ""){
      toast.warning("Currency is required")
    }
    else if(updateRate == "" | updateRate <= 0){
      toast.warning("Slot Rate is required")
    }
    else{
      const id = updateSlotRateId

      const data = {
        slot_agreement: updateSlotAgreement,
        container_type: updateContainerType,
        cargo_type: updateCargoType,
        currency: updateCurrency,
        rate: updateRate,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/'+id+'/', data,  
        {
          headers: { 'content-type': 'application/json'}
        }
      );
      if (response.status === 200 ) {
        toast.success("Slot Rate updated Successfully")
      }
      getSlotRate(updateId)
      setShowUpdateSlotRateModal(false)
    }
    setShowUpdateLoader(false)
  }

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="RateSheet" activeSubMenu="SlotAgreement" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Slot Agreement</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
            {
              currentUserRolePermissionData?.includes("master:slotagreement:add")?
                <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection"
                onClick={()=> [handleSetAddData(), handleSetAddData()]}>
                  <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                  <span className="fw-bold">Add Slot Agreement</span>
                </Button>
              :
                ""
            }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedRecord(recordForDelete?.id)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Update Record</h4>
              <Button className={`${showSlotAgreementDetails ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowSlotAgreementDetails(true), setShowSlotRates(false)]}>
                Details
              </Button>

              <Button className={`${showSlotRates ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowSlotAgreementDetails(false), setShowSlotRates(true)]}>
                Slot Rates
              </Button>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowUpdateCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <div style={{ display: showSlotAgreementDetails ? 'block' : 'none' }}>
            <form onSubmit={(e) => updateSlotAgreement(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="operator">Operator:  <i className="text-danger">*</i><span className="text-danger">{showUpdateOperatorError?" Operator required":""}</span></label>
                  <select name="operator" class="form-control form-control-sm" onChange={(e) => setUpdateOperator(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateOperatorError(true):setShowUpdateOperatorError(false)}>
                      <option value="">Select Operator</option>
                      {operatorData.map(operator => (
                      <option value={operator?.id} selected={operator?.id==updateOperator?true:false}>{operator?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="agent">Agent:  <i className="text-danger">*</i><span className="text-danger">{showUpdateAgentError?" Agent required":""}</span></label>
                  <select name="agent" class="form-control form-control-sm" onChange={(e) => setUpdateAgent(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateAgentError(true):setShowUpdateAgentError(false)}>
                      <option value="">Select Agent</option>
                      {agentData.map(agent => (
                      <option value={agent?.id} selected={agent?.id==updateAgent?true:false}>{agent?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="from_port">From Port:  <i className="text-danger">*</i><span className="text-danger">{showUpdateFromPortError?" Origin port required":""}</span></label>
                  <select name="from_port" class="form-control form-control-sm" onChange={(e) => [setUpdateFromPort(e.target.value), getUpdateService(e.target.value, updateToPort)]}
                          onBlur={(e) => e.target.value==""?setShowUpdateFromPortError(true):setShowUpdateFromPortError(false)}>
                      <option value="">Select Port</option>
                      {portData.map(port => (
                      <option value={port?.id} selected={port?.id==updateFromPort?true:false}>{port?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="to_port">To Port:  <i className="text-danger">*</i><span className="text-danger">{showUpdateToPortError?" Destination port required":""}</span></label>
                  <select name="to_port" class="form-control form-control-sm" onChange={(e) => [setUpdateToPort(e.target.value), getUpdateService(updateFromPort, e.target.value)]}
                          onBlur={(e) => e.target.value==""?setShowUpdateToPortError(true):setShowUpdateToPortError(false)}>
                      <option value="">Select Port</option>
                      {portData.map(port => (
                      <option value={port?.id} selected={port?.id==updateToPort?true:false}>{port?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="service">Vessel Service: <i className="text-danger">*</i><span className="text-danger">{showUpdateServiceError?" Vessel service required":""}</span></label>
                  <select name="service" class="form-control form-control-sm" onChange={(e) => setUpdateService(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateServiceError(true):setShowUpdateServiceError(false)}>
                      <option value="">Select Vessel Service</option>
                      {updateServiceData.map(service => (
                      <option value={service?.id} selected={service?.id==updateService?true:false}>{service?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="freight_terms_from">Freight Terms From:  <i className="text-danger">*</i><span className="text-danger">{showUpdateFreightTermsFromError?" Freight original terms required":""}</span></label>
                  <select className="form-select form-select-sm" name="freight_terms_from" onChange={(e) => setUpdateFreightTermsFrom(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateFreightTermsFromError(true):setShowUpdateFreightTermsFromError(false)}>
                    <option value="">Select Terms</option>
                    <option value="EXW" selected={updateFreightTermsFrom=="EXW"?true:false}>EXW (Ex Works)</option>
                    <option value="FCA" selected={updateFreightTermsFrom=="FCA"?true:false}>FCA (Free Carrier)</option>
                    <option value="FOB" selected={updateFreightTermsFrom=="FOB"?true:false}>FOB (Free On Board)</option>
                    <option value="FAS" selected={updateFreightTermsFrom=="FAS"?true:false}>FAS (Free Alongside Ship)</option>
                    <option value="CPT" selected={updateFreightTermsFrom=="CPT"?true:false}>CPT (Carriage Paid To)</option>
                    <option value="CIP" selected={updateFreightTermsFrom=="CIP"?true:false}>CIP (Carriage and Insurance Paid To)</option>
                    <option value="DAP" selected={updateFreightTermsFrom=="DAP"?true:false}>DAP (Delivered at Place)</option>
                    <option value="DPU" selected={updateFreightTermsFrom=="DPU"?true:false}>DPU (Delivered at Place Unloaded)</option>
                    <option value="DDP" selected={updateFreightTermsFrom=="DDP"?true:false}>DDP (Delivered Duty Paid)</option>
                    <option value="CY" selected={updateFreightTermsFrom=="CY"?true:false}>CY (Container Yard)</option>
                    <option value="CFS" selected={updateFreightTermsFrom=="CFS"?true:false}>CFS (Container Freight Station)</option>
                    <option value="PORT" selected={updateFreightTermsFrom=="PORT"?true:false}>PORT (Port of Loading)</option>
                    <option value="GATEIN" selected={updateFreightTermsFrom=="GATEIN"?true:false}>GATE IN (Gate In at Terminal)</option>
                    <option value="WH" selected={updateFreightTermsFrom=="WH"?true:false}>WH (Warehouse - Shipper's Warehouse)</option>
                    <option value="ICD" selected={updateFreightTermsFrom=="ICD"?true:false}>ICD (Inland Container Depot)</option>
                    <option value="DEPOT" selected={updateFreightTermsFrom=="DEPOT"?true:false}>DEPOT (Empty Container Depot)</option>
                    <option value="FO" selected={updateFreightTermsFrom=="FO"?true:false}>FO (Free Out - Buyer bears unloading costs at destination)</option>
                    <option value="FI" selected={updateFreightTermsFrom=="FI"?true:false}>FI (Free In - Buyer bears loading costs at origin)</option>
                    <option value="FIO" selected={updateFreightTermsFrom=="FIO"?true:false}>FIO (Free In and Out - Buyer bears both loading and unloading)</option>
                    <option value="FILO" selected={updateFreightTermsFrom=="FILO"?true:false}>FILO (Free In Liner Out)</option>
                    <option value="LIFO" selected={updateFreightTermsFrom=="LIFO"?true:false}>LIFO (Liner In Free Out)</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="freight_terms_to">Freight Terms To:  <i className="text-danger">*</i><span className="text-danger">{showUpdateFreightTermsToError?" Freight original terms required":""}</span></label>
                  <select className="form-select form-select-sm" name="freight_terms_to" onChange={(e) => setUpdateFreightTermsTo(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateFreightTermsToError(true):setShowUpdateFreightTermsToError(false)}>
                    <option value="">Select Terms</option>
                    <option value="CPT" selected={updateFreightTermsTo=="CPT"?true:false}>CPT (Carriage Paid To)</option>
                    <option value="CIP" selected={updateFreightTermsTo=="CIP"?true:false}>CIP (Carriage and Insurance Paid To)</option>
                    <option value="DAP" selected={updateFreightTermsTo=="DAP"?true:false}>DAP (Delivered At Place)</option>
                    <option value="DPU" selected={updateFreightTermsTo=="DPU"?true:false}>DPU (Delivered at Place Unloaded)</option>
                    <option value="DDP" selected={updateFreightTermsTo=="DDP"?true:false}>DDP (Delivered Duty Paid)</option>
                    <option value="CY" selected={updateFreightTermsTo=="CY"?true:false}>CY (Container Yard)</option>
                    <option value="CFS" selected={updateFreightTermsTo=="CFS"?true:false}>CFS (Container Freight Station)</option>
                    <option value="PORT" selected={updateFreightTermsTo=="PORT"?true:false}>PORT (Port of Discharge)</option>
                    <option value="GATEOUT" selected={updateFreightTermsTo=="GATEOUT"?true:false}>GATE OUT (Gate Out at Terminal)</option>
                    <option value="ICD" selected={updateFreightTermsTo=="ICD"?true:false}>ICD (Inland Container Depot)</option>
                    <option value="DEPOT" selected={updateFreightTermsTo=="DEPOT"?true:false}>DEPOT (Empty Container Depot)</option>
                    <option value="WH" selected={updateFreightTermsTo=="WH"?true:false}>WH (Warehouse - Consignee's Warehouse)</option>
                    <option value="ONBOARD" selected={updateFreightTermsTo=="ONBOARD"?true:false}>ONBOARD (Onboard Vessel)</option>
                    <option value="ANCHORAGE" selected={updateFreightTermsTo=="ANCHORAGE"?true:false}>ANCHORAGE (Anchorage Point)</option>
                    <option value="RAILRAMP" selected={updateFreightTermsTo=="RAILRAMP"?true:false}>RAIL RAMP (Rail Ramp Delivery Point)</option>
                    <option value="TRUCKPOINT" selected={updateFreightTermsTo=="TRUCKPOINT"?true:false}>TRUCK POINT (Truck Delivery Point)</option>
                    <option value="FO" selected={updateFreightTermsTo=="FO"?true:false}>FO (Free Out - Buyer bears unloading costs at destination)</option>
                    <option value="FI" selected={updateFreightTermsTo=="FI"?true:false}>FI (Free In - Buyer bears loading costs at origin)</option>
                    <option value="FIO" selected={updateFreightTermsTo=="FIO"?true:false}>FIO (Free In and Out - Buyer bears both loading and unloading)</option>
                    <option value="FILO" selected={updateFreightTermsTo=="FILO"?true:false}>FILO (Free In Liner Out)</option>
                    <option value="LIFO" selected={updateFreightTermsTo=="LIFO"?true:false}>LIFO (Liner In Free Out)</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidFromError?" Date required":""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_from" name="valid_from" placeholder="Enter Date" onChange={(e) => setUpdateValidFrom(e.target.value)}
                  value={updateValidFrom} onBlur={(e) => e.target.value=="" | e.target.value==null?setShowUpdateValidFromError(true):setShowUpdateValidFromError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="valid_upto">Valid Upto: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidUptoError?" Date required":""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_upto" name="valid_upto" placeholder="Enter Date" onChange={(e) => setUpdateValidUpto(e.target.value)}
                  value={updateValidUpto} onBlur={(e) => e.target.value=="" | e.target.value==null?setShowUpdateValidUptoError(true):setShowUpdateValidUptoError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="vendor_agreement_number">Vendor Agreement Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorAgreementNumberError?" Agreement Number required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="vendor_agreement_number" name="vendor_agreement_number" placeholder="Enter Number" onChange={(e) => setUpdateVendorAgreementNumber(e.target.value)}
                  value={updateVendorAgreementNumber} onBlur={(e) => e.target.value==""?setShowUpdateVendorAgreementNumberError(true):setShowUpdateVendorAgreementNumberError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="agreement_date">Agreement Date: <i className="text-danger">*</i><span className="text-danger">{showUpdateAgreementDateError?" Agreement Date required":""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="agreement_date" name="agreement_date" placeholder="Enter Date" onChange={(e) => setUpdateAgreementDate(e.target.value)}
                  value={updateAgreementDate} onBlur={(e) => e.target.value=="" | e.target.value==null?setShowUpdateAgreementDateError(true):setShowUpdateAgreementDateError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="notes">Notes: </label>
                  <input type="text" class="form-control form-control-sm" id="notes" name="notes" placeholder="Enter Notes" value={updateNotes} onChange={(e) => setUpdateNotes(e.target.value)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => updateSlotAgreement(e)}>
                    {showUpdateLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
                    </>
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
          </div>

          <div style={{ display: showSlotRates ? 'block' : 'none' }}>
            <div className="row" style={{ float: "inline-end"}}>
              <div className="col-12">
                <Button className="btn btn-sm btn-inox-green border-0" onClick={() => handleAddSlotRateModalOpen()}>
                  Add Slot Rate
                </Button>
              </div>
            </div>
            <DataTable
              columns={slotratecolumns}
              data={slotRateData}
              progressPending={slotRateDataPending}
              progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
              noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
              pagination
              highlightOnHover
              customStyles={userTableCustomStyles}
              dense
            />
          </div>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowAddCanvas(false), handleSetAddData()]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
            <form ref={addform} onSubmit={(e) => addNewSlotAgreement(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="operator">Operator:  <i className="text-danger">*</i><span className="text-danger">{showOperatorError?" Operator required":""}</span></label>
                  <select name="operator" class="form-control form-control-sm"
                          onBlur={(e) => e.target.value==""?setShowOperatorError(true):setShowOperatorError(false)}>
                      <option value="">Select Operator</option>
                      {operatorData.map(operator => (
                      <option value={operator?.id}>{operator?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="agent">Agent:  <i className="text-danger">*</i><span className="text-danger">{showAgentError?" Agent required":""}</span></label>
                  <select name="agent" class="form-control form-control-sm"
                          onBlur={(e) => e.target.value==""?setShowAgentError(true):setShowAgentError(false)}>
                      <option value="">Select Agent</option>
                      {agentData.map(agent => (
                      <option value={agent?.id}>{agent?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="from_port">From Port:  <i className="text-danger">*</i><span className="text-danger">{showFromPortError?" Origin port required":""}</span></label>
                  <select name="from_port" class="form-control form-control-sm" onChange={(e) => setFromPort(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowFromPortError(true):setShowFromPortError(false)}>
                      <option value="">Select Port</option>
                      {portData.map(port => (
                      <option value={port?.id}>{port?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="to_port">To Port:  <i className="text-danger">*</i><span className="text-danger">{showToPortError?" Destination port required":""}</span></label>
                  <select name="to_port" class="form-control form-control-sm" onChange={(e) => getService(fromPort, e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowToPortError(true):setShowToPortError(false)}>
                      <option value="">Select Port</option>
                      {portData.map(port => (
                      <option value={port?.id}>{port?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="service">Vessel Service: <i className="text-danger">*</i><span className="text-danger">{showServiceError?" Vessel service required":""}</span></label>
                  <select name="service" class="form-control form-control-sm"
                          onBlur={(e) => e.target.value==""?setShowServiceError(true):setShowServiceError(false)}>
                      <option value="">Select Vessel Service</option>
                      {serviceData.map(service => (
                      <option value={service?.id}>{service?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="freight_terms_from">Freight Terms From:  <i className="text-danger">*</i><span className="text-danger">{showFreightTermsFromError?" Freight original terms required":""}</span></label>
                  <select className="form-select form-select-sm" name="freight_terms_from"
                          onBlur={(e) => e.target.value==""?setShowFreightTermsFromError(true):setShowFreightTermsFromError(false)}>
                    <option value="">Select Terms</option>
                    <option value="EXW">EXW (Ex Works)</option>
                    <option value="FCA">FCA (Free Carrier)</option>
                    <option value="FOB">FOB (Free On Board)</option>
                    <option value="FAS">FAS (Free Alongside Ship)</option>
                    <option value="CPT">CPT (Carriage Paid To)</option>
                    <option value="CIP">CIP (Carriage and Insurance Paid To)</option>
                    <option value="DAP">DAP (Delivered at Place)</option>
                    <option value="DPU">DPU (Delivered at Place Unloaded)</option>
                    <option value="DDP">DDP (Delivered Duty Paid)</option>
                    <option value="CY">CY (Container Yard)</option>
                    <option value="CFS">CFS (Container Freight Station)</option>
                    <option value="PORT">PORT (Port of Loading)</option>
                    <option value="GATEIN">GATE IN (Gate In at Terminal)</option>
                    <option value="WH">WH (Warehouse - Shipper\'s Warehouse)</option>
                    <option value="ICD">ICD (Inland Container Depot)</option>
                    <option value="DEPOT">DEPOT (Empty Container Depot)</option>
                    <option value="FO">FO (Free Out - Buyer bears unloading costs at destination)</option>
                    <option value="FI">FI (Free In - Buyer bears loading costs at origin)</option>
                    <option value="FIO">FIO (Free In and Out - Buyer bears both loading and unloading)</option>
                    <option value="FILO">FILO (Free In Liner Out)</option>
                    <option value="LIFO">LIFO (Liner In Free Out)</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="freight_terms_to">Freight Terms To:  <i className="text-danger">*</i><span className="text-danger">{showFreightTermsToError?" Freight original terms required":""}</span></label>
                  <select className="form-select form-select-sm" name="freight_terms_to"
                          onBlur={(e) => e.target.value==""?setShowFreightTermsToError(true):setShowFreightTermsToError(false)}>
                    <option value="">Select Terms</option>
                    <option value="CPT">CPT (Carriage Paid To)</option>
                    <option value="CIP">CIP (Carriage and Insurance Paid To)</option>
                    <option value="DAP">DAP (Delivered At Place)</option>
                    <option value="DPU">DPU (Delivered at Place Unloaded)</option>
                    <option value="DDP">DDP (Delivered Duty Paid)</option>
                    <option value="CY">CY (Container Yard)</option>
                    <option value="CFS">CFS (Container Freight Station)</option>
                    <option value="PORT">PORT (Port of Discharge)</option>
                    <option value="GATEOUT">GATE OUT (Gate Out at Terminal)</option>
                    <option value="ICD">ICD (Inland Container Depot)</option>
                    <option value="DEPOT">DEPOT (Empty Container Depot)</option>
                    <option value="WH">WH (Warehouse - Consignee\'s Warehouse)</option>
                    <option value="ONBOARD">ONBOARD (Onboard Vessel)</option>
                    <option value="ANCHORAGE">ANCHORAGE (Anchorage Point)</option>
                    <option value="RAILRAMP">RAIL RAMP (Rail Ramp Delivery Point)</option>
                    <option value="TRUCKPOINT">TRUCK POINT (Truck Delivery Point)</option>
                    <option value="FO">FO (Free Out - Buyer bears unloading costs at destination)</option>
                    <option value="FI">FI (Free In - Buyer bears loading costs at origin)</option>
                    <option value="FIO">FIO (Free In and Out - Buyer bears both loading and unloading)</option>
                    <option value="FILO">FILO (Free In Liner Out)</option>
                    <option value="LIFO">LIFO (Liner In Free Out)</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showValidFromError?" Date required":""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_from" name="valid_from" placeholder="Enter Date"
                  onBlur={(e) => e.target.value=="" | e.target.value==null?setShowValidFromError(true):setShowValidFromError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="valid_upto">Valid Upto: <i className="text-danger">*</i><span className="text-danger">{showValidUptoError?" Date required":""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_upto" name="valid_upto" placeholder="Enter Date"
                  onBlur={(e) => e.target.value=="" | e.target.value==null?setShowValidUptoError(true):setShowValidUptoError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="vendor_agreement_number">Vendor Agreement Number: <i className="text-danger">*</i><span className="text-danger">{showVendorAgreementNumberError?" Agreement Number required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="vendor_agreement_number" name="vendor_agreement_number" placeholder="Enter Number"
                  onBlur={(e) => e.target.value==""?setShowVendorAgreementNumberError(true):setShowVendorAgreementNumberError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="agreement_date">Agreement Date: <i className="text-danger">*</i><span className="text-danger">{showAgreementDateError?" Agreement Date required":""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="agreement_date" name="agreement_date" placeholder="Enter Date"
                  onBlur={(e) => e.target.value=="" | e.target.value==null?setShowAgreementDateError(true):setShowAgreementDateError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="notes">Notes: </label>
                  <input type="text" class="form-control form-control-sm" id="notes" name="notes" placeholder="Enter Notes"/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => addNewSlotAgreement(e)}>
                  {showAddLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                    </>
                  }
                  </Button>
                </div>
              </div>
            </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}

      {/* ------------------------- Slot Rate --------------------- */}
      <Modal size="sm" show={showDeleteSlotRateModal} onHide={handleDeleteSlotRateModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteSlotRateModalClose}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedSlotRateRecord(slotRateRecordForDelete?.id)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="xl" show={showUpdateSlotRateModal} onHide={() => setShowUpdateSlotRateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => updateSlotRate(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="slot_agreement">Slot Agreement: <i className="text-danger">*</i><span className="text-danger">{showUpdateSlotAgreementError?" Slot agreement required":""}</span></label>
                <select name="slot_agreement" class="form-control form-control-sm" 
                        onChange={(e) => setUpdateSlotRateAgreement(e.target.value)}
                        onBlur={(e) => e.target.value==""?setShowUpdateSlotAgreementError(true):setShowUpdateSlotAgreementError(false)} disabled>
                    <option value="">Select Slot Agreement</option>
                    {data.map(slot_agreement => (
                    <option value={slot_agreement?.id} selected={slot_agreement?.id==updateSlotRateAgreement?true:false}>{slot_agreement?.operator_data?.name} ({slot_agreement?.from_port_data?.name} - {slot_agreement?.to_port_data?.name})</option>
                    ))}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="container_type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateContainerTypeError?" Container type required":""}</span></label>
                <select name="container_type" class="form-control form-control-sm"  
                        onChange={(e) => setUpdateContainerType(e.target.value)}
                        onBlur={(e) => e.target.value==""?setShowUpdateContainerTypeError(true):setShowUpdateContainerTypeError(false)}>
                    <option value="">Select Container Type</option>
                    {containerTypeData.map(container => (
                    <option value={container?.id} selected={updateContainerType==container.id?true:false}>{container?.product_name}</option>
                    ))}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateCargoTypeError?" Cargo type required":""}</span></label>
                <select className="form-select form-select-sm" name="cargo_type" 
                        onChange={(e) => setUpdateCargoType(e.target.value)}
                        onBlur={(e) => e.target.value==""?setShowUpdateCargoTypeError(true):setShowUpdateCargoTypeError(false)}>
                  <option value="" selected={updateCargoType==""?true:false}>Select Cargo Type</option>
                  <option value="HAZARDOUS" selected={updateCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                  <option value="NON_HAZARDOUS" selected={updateCargoType=="NON_HAZARDOUS"?true:false}>NON HAZARDOUS</option>
                  <option value="EMPTY" selected={updateCargoType=="EMPTY"?true:false}>EMPTY</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showUpdateCurrencyError?" Currency required":""}</span></label>
                <select name="currency" class="form-control form-control-sm" onChange={(e) => setUpdateCurrency(e.target.value)}
                        onBlur={(e) => e.target.value==""?setShowUpdateCurrencyError(true):setShowUpdateCurrencyError(false)}>
                    <option value="">Select Currency</option>
                    {currencyData.map(currency => (
                    <option value={currency?.id} selected={updateCurrency==currency.id?true:false}>{currency?.name} {currency?.symbol}</option>
                    ))}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="rate">Rate: <i className="text-danger">*</i><span className="text-danger">{showUpdateRateError?" Rate required":""}</span></label>
                <input type="number" class="form-control form-control-sm" id="rate" name="rate" placeholder="Enter Rate" value={updateRate} onChange={(e) => setUpdateRate(e.target.value)}
                onBlur={(e) => e.target.value=="" ?setShowUpdateRateError(true):setShowUpdateRateError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-12 text-center":"col-md-12 text-center"}`}>
                <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => updateSlotRate(e)}>
                  {showUpdateLoader?
                    <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                  :
                  <>
                    <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
                  </>
                  }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal size="xl" show={showAddSlotRateModal} onHide={() => setShowAddSlotRateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Slot Rate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form ref={addslotrateform} onSubmit={(e) => addNewSlotRate(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="slot_agreement">Slot Agreement: <i className="text-danger">*</i><span className="text-danger">{showSlotAgreementError?" Slot agreement required":""}</span></label>
                <select name="slot_agreement" class="form-control form-control-sm"
                        onBlur={(e) => e.target.value==""?setShowSlotAgreementError(true):setShowSlotAgreementError(false)}>
                    <option value="">Select Slot Agreement</option>
                    {data.map(slot_agreement => (
                    <option value={slot_agreement?.id}>{slot_agreement?.operator_data?.name} {slot_agreement?.from_port_data?.name} - {slot_agreement?.to_port_data?.name}</option>
                    ))}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="container_type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showContainerTypeError?" Container type required":""}</span></label>
                <select name="container_type" class="form-control form-control-sm"
                        onBlur={(e) => e.target.value==""?setShowContainerTypeError(true):setShowContainerTypeError(false)}>
                    <option value="">Select Container Type</option>
                    {containerTypeData.map(container => (
                    <option value={container?.id} selected={updateContainerType==container.id?true:false}>{container?.product_name}</option>
                    ))}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showCargoTypeError?" Cargo type required":""}</span></label>
                <select className="form-select form-select-sm" name="cargo_type" onBlur={(e) => e.target.value==""?setShowCargoTypeError(true):setShowCargoTypeError(false)}>
                  <option value="">Select Cargo Type</option>
                  <option value="HAZARDOUS">HAZARDOUS</option>
                  <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                  <option value="EMPTY">EMPTY</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showCurrencyError?" Currency required":""}</span></label>
                <select name="currency" class="form-control form-control-sm" onBlur={(e) => e.target.value==""?setShowCurrencyError(true):setShowCurrencyError(false)}>
                    <option value="">Select Currency</option>
                    {currencyData.map(currency => (
                    <option value={currency?.id}>{currency?.name} {currency?.symbol}</option>
                    ))}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                <label for="rate">Rate: <i className="text-danger">*</i><span className="text-danger">{showRateError?" Rate required":""}</span></label>
                <input type="number" className="form-control form-control-sm" id="rate" name="rate" placeholder="Enter Rate"
                      onBlur={(e) => e.target.value==""?setShowRateError(true):setShowRateError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => addNewSlotRate(e)}>
                {showAddLoader?
                    <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                  :
                  <>
                    <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                  </>
                }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SlotAgreement;
